<template>
  <a v-if="result" :href="result?.link" class="package-banner">
    <DefPicture :result="result.pictures" />
  </a>
</template>

<script>
import { mapState } from 'vuex';
import DefPicture from '@components/Def/DefPicture/DefPicture.vue';

export default {
  name: 'PackageBanner',
  components: { DefPicture },
  computed: {
    ...mapState({
      result: ({ product }) => product.data?.product?.banners?.package,
    }),
  },
};
</script>

<style lang="scss" scoped>
.package-banner {
  display: block;
  margin: 26px 0 48px;
  @include point-md {
    margin: 42px 0 64px;
  }
  @include point-lg {
    margin: 0 0 64px;
  }
}

:deep {
  .def-picture img {
    width: 100%;
  }
}
</style>
